<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.INQUIRY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry1Code" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry2Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry2CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.USEDMODULE') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <select class="slt_white w100" v-model="useModule">
                                    <option v-for="item in useModuleList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.KPIINCHARGE') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <select class="slt_white w100" v-model="kpiCharge">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in kpiChargeList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.STATUS') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <select
                                    class="slt_white w100"
                                    v-model="statusCd"
                                    :disabled="getTabDisabled('statusCd')"
                                >
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in statusCdList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</li>
                            <li data-input-type="date" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select
                                            class="slt_white w100"
                                            v-model="rhqCode"
                                            @change="categoryList(5)"
                                            :disabled="getTabDisabled('rhqCode')"
                                        >
                                            <option value="" v-if="getAdmin('rhqCode')">
                                                {{ $t('FIELD.FAST.DURATION.ALL') }}
                                            </option>
                                            <option
                                                v-for="item in rhqCodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select
                                            class="slt_white w100"
                                            v-model="subsidiary"
                                            :disabled="getTabDisabled('subsidiary')"
                                        >
                                            <option value="" v-if="getAdmin('subsidiary')">
                                                {{ $t('FIELD.FAST.DURATION.ALL') }}
                                            </option>
                                            <option
                                                v-for="item in subsidiaryList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.USEYNBYSUB') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <select class="slt_white w100" v-model="useYn" :disabled="getTabDisabled('useYn')">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in useYnList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.LEVEL') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="levelCd" :disabled="getTabDisabled('levelCd')">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </select>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                                {{ $t('BUTTON.GLOBAL.SEARCH') }}</a
                            >
                        </span>
                    </div>
                </article>
            </div>
            <!--tab-->
            <div class="tab_wrap">
                <ul class="tab_menu_04 tab_menus">
                    <li class="on" @click="tabClick(1)">
                        <a href="javascript:">{{ $t('FIELD.GLOBAL.MASTER') }}</a>
                    </li>
                    <li class="" @click="tabClick(2)">
                        <a href="javascript:">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</a>
                    </li>
                    <div class="btn_wrap fR">
                        <a
                            href="javascript:"
                            class="btn_sm_white"
                            v-if="getTabDisabled('inquiryAddPop')"
                            @click="inquiryPop('Add')"
                        >
                            {{ $t('BUTTON.GLOBAL.ADD') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_sm_white"
                            v-if="getTabDisabled('inquiryEditPop')"
                            @click="inquiryPop('Edit')"
                        >
                            {{ $t('BUTTON.GLOBAL.EDIT') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_sm_white"
                            v-if="getTabDisabled('inquiryDisplayYN')"
                            @click="inquiryDisplayYN()"
                        >
                            {{ $t('BUTTON.GLOBAL.CHANGESTATUS') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_sm_white"
                            v-if="getTabDisabled('excelDownloadMaster')"
                            @click="onExcel('MASTER')"
                        >
                            {{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_sm_white"
                            v-if="getTabDisabled('excelDownloadSubsidiary')"
                            @click="onExcel('SUBSIDIARY')"
                        >
                            {{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}
                        </a>
                    </div>
                </ul>
                <div class="tab_contents">
                    <div class="tab_cont">
                        <!-- Grid -->
                        <div class="grid_wrap">
                            <!-- Count -->
                            <div class="grid_total">
                                {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCountMaster }}</em>
                            </div>
                            <!-- Grid -->
                            <toast-grid
                                gridId="masterInquiryManageListGrid"
                                :columns="columnsMaster"
                                :data="gridDataMaster"
                                :options="options"
                                ref="masterInquiryManageListGrid"
                                :key="gridKeyMaster"
                                :isTotalCount="false"
                            />
                        </div>
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="currentPageMaster"
                                :total-rows="totalCountMaster"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </div>
                    <div class="tab_cont" style="display: none;">
                        <!-- Grid -->
                        <div class="grid_wrap">
                            <!-- Count -->
                            <div class="grid_total">
                                {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCountSubsidiary }}</em>
                            </div>
                            <!-- Grid -->
                            <toast-grid
                                gridId="subsidiaryInquiryManageListGrid"
                                :columns="columnsSubsidiary"
                                :data="gridDataSubsidiary"
                                :options="options"
                                ref="subsidiaryInquiryManageListGrid"
                                :key="gridKeySubsidiary"
                                :isTotalCount="false"
                            />
                        </div>
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="currentPageSubsidiary"
                                :total-rows="totalCountSubsidiary"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import constants from '@/constants';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';
import inquiryAddPop from '~va/qnaManager/popup/inquiryAddPop';

export default {
    name: 'inquiryManageList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'inquiryManageList',
            pageTitle: '',
            selectTab: 0,
            searchDiv: 'MASTER',
            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            rhqCode: '',
            rhqCodeList: [],
            subsidiary: '',
            subsidiaryList: [],
            kpiCharge: '',
            kpiChargeList: [],
            useModule: 'ALL',
            useModuleList: [],
            useYn: '',
            useYnList: [],
            statusCd: '',
            statusCdList: [],
            levelCd: '',
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            totalCountMaster: 0,
            currentPageMaster: 1,
            gridKeyMaster: 0,
            gridDataMaster: [],
            totalCountSubsidiary: 0,
            currentPageSubsidiary: 1,
            gridKeySubsidiary: 0,
            gridDataSubsidiary: [],
            options: {
                scrollX: true,
                scrollY: true,
                header: { height: 45 },
                rowHeight: 45,
                rowHeaders: ['checkbox'],
            },
            columnsMaster: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LEVEL'),
                    name: 'LEVEL_CD',
                    align: 'center',
                    width: 100,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRYTYPE_1',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRYTYPE_2',
                    align: 'center',
                    width: 500,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USEDMODULE'),
                    name: 'USE_MODULE_NM',
                    align: 'center',
                    width: 150,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.KPIINCHARGE'),
                    name: 'KPI_CHARGE_NM',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'STATUS_NM',
                    align: 'center',
                    width: 125,
                    resizable: true,
                    sortable: false,
                },
            ],
            columnsSubsidiary: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.RHQ'),
                    name: 'RHQ_NM',
                    align: 'center',
                    width: 175,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                    name: 'SUBSIDIARY_NM',
                    align: 'center',
                    width: 150,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRYTYPE1',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRYTYPE2',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USEDMODULE'),
                    name: 'USE_MODULE_NM',
                    align: 'center',
                    width: 175,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.KPIINCHARGE'),
                    name: 'KPI_CHARGE_NM',
                    align: 'center',
                    width: 250,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'USEYN',
                    align: 'center',
                    width: 125,
                    resizable: true,
                    sortable: false,
                },
            ],
        };
    },
    mounted() {
        this.categoryList(4);
        this.inquiryList(1);
        this.inquiryList(3);
        this.inquiryList(5);
        this.inquiryList(6);
        this.inquiryList(7);

        setTimeout(() => {
            this.onSearch(1);
        }, 1000);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
        }),
    },
    methods: {
        async onSearch(v) {
            let systemAdminYN = 'N';

            if (this.roles.includes('9900') || this.roles.includes('9999')) {
                systemAdminYN = 'Y';
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/inquirySearch.skp`,
                    qs.stringify({
                        page: v,
                        searchInfo: 'set',
                        SEARCH_DIV: this.searchDiv,
                        inquiryType1: this.inquiry1Code,
                        inquiryType2: this.inquiry2Code,
                        use_module: this.useModule,
                        kpi_charge: this.kpiCharge,
                        useyn: this.useYn,
                        rhqCode: this.rhqCode,
                        searchSubsidiary: this.subsidiary,
                        status_cd: this.statusCd,
                        level_cd: this.levelCd,
                        systemAdminYN: systemAdminYN,
                    }),
                )
                .then(resp => {
                    if ('MASTER' === resp.data.search.SEARCH_DIV) {
                        this.gridDataMaster = resp.data.result.rowData;
                        for (const iterator of this.gridDataMaster) {
                            if (!SDLUtil.isNull(iterator.INQUIRYTYPE2)) {
                                iterator.INQUIRYTYPE_2 = iterator.INQUIRYTYPE1 + ' > ' + iterator.INQUIRYTYPE2;
                                iterator.INQUIRYTYPE_1 = '';
                            } else {
                                iterator.INQUIRYTYPE_2 = iterator.INQUIRYTYPE2;
                                iterator.INQUIRYTYPE_1 = iterator.INQUIRYTYPE1;
                            }
                        }
                        this.totalCountMaster = resp.data.search.totalRecords;
                        this.currentPageMaster = Number(resp.data.search.page);
                        this.gridKeyMaster++;
                    } else if ('SUBSIDIARY' === resp.data.search.SEARCH_DIV) {
                        this.gridDataSubsidiary = resp.data.result.rowData;
                        this.totalCountSubsidiary = resp.data.search.totalRecords;
                        this.currentPageSubsidiary = Number(resp.data.search.page);
                        this.gridKeySubsidiary++;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onExcel(v) {
            let systemAdminYN = 'N';
            let url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/excelDownloadMaster.skp`;

            if (this.roles.includes('9900') || this.roles.includes('9999')) {
                systemAdminYN = 'Y';
            }

            if ('SUBSIDIARY' === v) {
                url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/excelDownloadSubsidiary.skp`;
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.EXCEL.ALERT.MAXROWS'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                searchInfo: 'set',
                                SEARCH_DIV: this.searchDiv,
                                inquiryType1: this.inquiry1Code,
                                inquiryType2: this.inquiry2Code,
                                use_module: this.useModule,
                                kpi_charge: this.kpiCharge,
                                useyn: this.useYn,
                                rhqCode: this.rhqCode,
                                searchSubsidiary: this.subsidiary,
                                status_cd: this.statusCd,
                                level_cd: this.levelCd,
                                systemAdminYN: systemAdminYN,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 3) {
                type = 'kpi_charge';
            } else if (v === 5) {
                type = 'use_module';
            } else if (v === 6) {
                type = 'useyn';
            } else if (v === 7) {
                type = 'status_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    } else if (v === 3) {
                        this.kpiChargeList = resp.data.result.rowData;
                    } else if (v === 5) {
                        this.useModule = 'ALL';
                        this.useModuleList = resp.data.result.rowData;
                    } else if (v === 6) {
                        this.useYn = '';
                        this.useYnList = resp.data.result.rowData;
                    } else if (v === 7) {
                        this.statusCd = '';
                        this.statusCdList = resp.data.result.rowData;
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 4) {
                codeCategoryId = 'RHQ_DATA_ACCESS_CD';
                parentCode = 'organizationRoot';
                this.rhqCode = '';
                this.rhqCodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                    this.rhqCodeList = resp;
                    this.rhqCode = resp[0].code;
                    this.categoryList(5);
                });
            } else if (v === 5) {
                codeCategoryId = 'SUB_DATA_ACCESS_CD';
                parentCode = this.rhqCode;
                this.subsidiary = '';
                this.subsidiaryList = [];
                if (!SDLUtil.isNull(parentCode)) {
                    await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                        this.subsidiaryList = resp;
                        this.subsidiary = resp[0].code;
                    });
                }
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        getAdmin(v) {
            let result = false;
            if (this.roles.includes(`${constants.SYSTEM_ADMIN}`)) {
                result = true;
            }
            if (this.roles.includes(`${constants.GBM_ADMIN}`)) {
                result = true;
            }
            if (this.roles.includes(`${constants.RHQ_ADMIN}`)) {
                if ('subsidiary' === v) result = true;
            }
            return result;
        },
        getTabDisabled(v) {
            let result = false;
            if (this.searchDiv === 'MASTER') {
                if ('inquiryAddPop' === v) {
                    result = true;
                } else if ('inquiryEditPop' === v) {
                    result = true;
                } else if ('excelDownloadMaster' === v) {
                    result = true;
                } else if ('excelDownloadSubsidiary' === v) {
                    result = false;
                } else if ('inquiryDisplayYN' === v) {
                    result = false;
                } else if ('useYn' === v) {
                    result = true;
                    this.useYn = '';
                } else if ('rhqCode' === v) {
                    result = true;
                    this.rhqCode = '';
                } else if ('subsidiary' === v) {
                    result = true;
                    this.subsidiary = '';
                } else if ('statusCd' === v) {
                    result = false;
                } else if ('levelCd' === v) {
                    result = false;
                }
            } else if (this.searchDiv === 'SUBSIDIARY') {
                if ('inquiryAddPop' === v) {
                    result = false;
                } else if ('inquiryEditPop' === v) {
                    result = false;
                } else if ('excelDownloadMaster' === v) {
                    result = false;
                } else if ('excelDownloadSubsidiary' === v) {
                    result = true;
                } else if ('inquiryDisplayYN' === v) {
                    result = true;
                } else if ('useYn' === v) {
                    result = false;
                } else if ('rhqCode' === v) {
                    result = false;
                } else if ('subsidiary' === v) {
                    result = false;
                } else if ('statusCd' === v) {
                    result = true;
                    this.statusCd = '';
                } else if ('levelCd' === v) {
                    result = true;
                    this.levelCd = '';
                }
            }
            return result;
        },
        tabClick(v) {
            let index = v - 1;
            $('.tab_wrap li').removeClass('on');
            $('.tab_wrap li')
                .eq(index)
                .addClass('on');
            $('.tab_wrap .tab_cont').hide();
            $('.tab_wrap .tab_cont')
                .eq(index)
                .show();
            this.selectTab = index;
            if (this.selectTab == 1) {
                this.searchDiv = 'SUBSIDIARY';
            } else {
                this.searchDiv = 'MASTER';
            }
        },
        buttonCheck(v) {
            let msg = '';
            let result = false;

            let grid = this.$refs[this.searchDiv.toLowerCase() + 'InquiryManageListGrid'].$refs[
                this.searchDiv.toLowerCase() + 'InquiryManageListGrid'
            ];
            let getData = grid.invoke('getData');
            let gridChecked = false;
            let cnt = 0;
            for (const data of getData) {
                if (data._attributes.checked) {
                    gridChecked = true;
                    cnt++;
                }
            }

            if (!gridChecked) {
                msg = SDLUtil.getMsgProp('MESSAGE.DATA.CHECKITEM');
                result = true;
            }

            if ('inquiryPop' === v && 1 < cnt) {
                msg = 'Please only one select box';
                result = true;
            }

            return [result, msg];
        },
        inquiryPop(v) {
            let listCheck = [];
            let LEVEL_CD = '';
            let INQUIRYTYPECD1 = '';
            let INQUIRYTYPE1 = '';
            let USE_MODULE = '';
            let KPI_CHARGE = '';
            let STATUS_CD = '';
            if ('Edit' === v) {
                let checkResult = this.buttonCheck('inquiryPop');
                if (checkResult[0]) return SDLUtil.alert(checkResult[1]);

                let grid = this.$refs[this.searchDiv.toLowerCase() + 'InquiryManageListGrid'].$refs[
                    this.searchDiv.toLowerCase() + 'InquiryManageListGrid'
                ];
                let getData = grid.invoke('getData');
                for (const data of getData) {
                    if (data._attributes.checked) {
                        listCheck.push(data.INQUIRY_TYPE_CD);
                        LEVEL_CD = String(data.LEVEL_CD);
                        INQUIRYTYPECD1 = data.P_CD;
                        INQUIRYTYPE1 = data.INQUIRYTYPE1;
                        USE_MODULE = data.USE_MODULE;
                        KPI_CHARGE = data.KPI_CHARGE;
                        STATUS_CD = data.STATUS_CD;
                    }
                }
            }
            SDLUtil.show(
                inquiryAddPop,
                {
                    SEARCH_DIV: this.searchDiv,
                    listCheck: listCheck,
                    inquiry1CodeList: this.inquiry1CodeList,
                    useModuleList: this.useModuleList,
                    kpiChargeList: this.kpiChargeList,
                    statusCdList: this.statusCdList,
                    LEVEL_CD: LEVEL_CD,
                    INQUIRYTYPECD1: INQUIRYTYPECD1,
                    INQUIRYTYPE1: INQUIRYTYPE1,
                    USE_MODULE: USE_MODULE,
                    KPI_CHARGE: KPI_CHARGE,
                    STATUS_CD: STATUS_CD,
                    rtnFunc: () => {
                        this.onSearch(1);
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        inquiryDisplayYN() {
            let checkResult = this.buttonCheck('inquiryDisplayYN');
            if (checkResult[0]) return SDLUtil.alert(checkResult[1]);

            let grid = this.$refs[this.searchDiv.toLowerCase() + 'InquiryManageListGrid'].$refs[
                this.searchDiv.toLowerCase() + 'InquiryManageListGrid'
            ];
            let getData = grid.invoke('getData');
            let listCheck = [];
            for (const data of getData) {
                if (data._attributes.checked) {
                    listCheck.push(data.INQUIRY_TYPE_CD + '!' + data.SUBSIDIARY_CD);
                }
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.MODIFY.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/inquiryDisplayYN.skp`,
                            qs.stringify({
                                listIqSubCd: listCheck,
                                modfUser: this.loginNo,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.alert(resp.data.msg);
                            SDLUtil.showLoadingBar(false);
                            return this.onSearch(1);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/inquiryManageList.vue